import { UPDATE_SHARD_ID } from '../actions';

export function shardId(state = '', action) {
  switch (action.type) {
    case UPDATE_SHARD_ID: {
      return action.shardId;
    }
    default:
      return state;
  }
}
